export const ErrorMessage = {
  gender:"Por favor, selecciona una opción",
  providePrimaryDOB: 'Para continuar, introduce una fecha válida',
  insurerInvalidAge: 'El asegurado no puede ser mayor de 100 años',
  futureDate: 'La fecha no puede ser futura',
  postalCode: "Para continuar, introduce un código postal válido",
  email: "Para continuar, introduce un email con este formato: nombre@dominio.com",
  privacy: "Por favor, acepta el Aviso Legal y la Política de Privacidad",
  telePhone:"Por favor, introduce un teléfono válido"
}
